import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class CommerceCheckout extends BaseStrapiCollection {
    constructor() {
        super("collectionType", "commerce-checkout", "commerce-checkouts");
    }

    async quote(data) {
        return this.postAction("/commerce-checkout/quote", data);
    }

    async checkout(data) {
        return this.postAction("/commerce-checkout", data);
    }
}
